const React = require('react');

module.exports = ({percent}) => {
  const additionalClass = percent === 0 ? '' : percent > 0 ? 'positive' : 'negative';
  return (
    <div className={`
      referral-percentage layoutRow aiC
      (dB|f16|lh24|fw7)>.referral-percentage__number
      (w0|h0|dB|ml5|bs|bcT|b|bh6|bb12)>.referral-percentage__triangle
      (c2CE889).positive>.referral-percentage__number
      (bcb2CE889).positive>.referral-percentage__triangle
      (cE82C2C).negative>.referral-percentage__number
      (bcbE82C2C|x0y0rz180deg).negative>.referral-percentage__triangle
      ${additionalClass}
    `}>
      <span className="referral-percentage__number">{percent}%</span>
      <span className="referral-percentage__triangle" />
    </div>
  )
}